var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9045 3.97679L14.4143 1.44126C13.8267 0.842981 13.0002 0.5 12.1461 0.5H4.16467C3.10231 0.5 2.23821 1.33409 2.23821 2.35957V6.09414H1.92646C0.864096 6.09414 0 6.92823 0 7.9537V14.8981C0 15.9236 0.864096 16.7577 1.92646 16.7577H2.23821V18.6404C2.23821 19.6659 3.10231 20.5 4.16467 20.5H15.8353C16.8977 20.5 17.7618 19.6659 17.7618 18.6404V16.7577H18.0735C19.1359 16.7577 20 15.9236 20 14.8981V7.9537C20 6.92823 19.1359 6.09414 18.0735 6.09414H17.7618V6.05251C17.7618 5.277 17.4572 4.53961 16.9045 3.97679ZM3.69304 2.35957C3.69304 2.10865 3.90473 1.90432 4.16467 1.90432H12.1461C12.6024 1.90432 13.0446 2.08781 13.3585 2.40747L15.8487 4.943C16.1443 5.24399 16.307 5.63777 16.307 6.05251V6.09414H3.69304V2.35957ZM18.5452 14.8981C18.5452 15.1491 18.3335 15.3534 18.0735 15.3534H1.92646C1.66652 15.3534 1.45484 15.1491 1.45484 14.8981V7.9537C1.45484 7.70279 1.66652 7.49846 1.92646 7.49846H18.0735C18.3335 7.49846 18.5452 7.70279 18.5452 7.9537V14.8981ZM16.307 18.6404C16.307 18.8913 16.0953 19.0957 15.8353 19.0957H4.16467C3.90473 19.0957 3.69304 18.8913 3.69304 18.6404V16.7577H16.307V18.6404Z",
    fill: "url(#paint0_linear_6749_8727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6749_8727",
    x1: 0,
    y1: 0.5,
    x2: 20,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.415347876a321189d0a54c384ea7442b.svg";
export { ForwardRef as ReactComponent };